import { render, staticRenderFns } from "./Lookup.vue?vue&type=template&id=535b5825"
import script from "./Lookup.vue?vue&type=script&lang=js"
export * from "./Lookup.vue?vue&type=script&lang=js"
import style0 from "./Lookup.vue?vue&type=style&index=0&id=535b5825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@3.6.0_webpack@4.47.0__ejs@3.1.10_be517b630ad34e2df4a68e8854480672/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports